import Home from './routes/Home.svelte'
import Settings from './routes/Settings.svelte'
import Apps from './routes/Apps.svelte'

const routes = {
  '/': Home,
  '/apps': Apps,
  '/settings': Settings
}

export default routes
